const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/TreatmentReasonSelector.tsx';
import { FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import textMap from '../translations';
import { useIntl } from 'react-intl';
import { TreatmentReasonListItem } from 'App/defs/types';
import { css } from '@emotion/css';
import { colors } from '@cistec/common_web/defs/colors';

type TreatmentReasonProps = {
    classes: any;
    onChange: (elem: SelectChangeEvent<string>) => void;
    reasonList: TreatmentReasonListItem[] | null;
    defaultValue: TreatmentReasonListItem | null;
    value: TreatmentReasonListItem | null;
};

const getMainContainerClass = () => ({
    labelStyle: css`
        color: ${colors.grey['500']};
    `,
    selectInput: css`
        display: flex;
        flex-basis: 100%;
        height: 44px;
        & > .MuiSelect-select {
            height: 75%;
        }
        & fieldset {
            top: 0;
        }
        & fieldset > legend {
            display: none;
        }
    `,
});

export const TreatmentReasonSelector = (props: TreatmentReasonProps) => {
    const { classes, reasonList, onChange } = props;
    const { formatMessage } = useIntl();

    const mainContainer = getMainContainerClass();
    const noOptionsAvailable = !reasonList || reasonList.length === 0;
    const disabled = noOptionsAvailable;
    const noOptionsValue = 'none';
    const defaultValue: string = noOptionsAvailable ? noOptionsValue : props.defaultValue?.fkey || '';
    const value = props.value?.fkey || defaultValue;

    const renderMenuItem = (reason: TreatmentReasonListItem) => (
        <MenuItem key={reason.fkey} value={reason.fkey}>
            <div className="lineClampText">{reason.name}</div>
        </MenuItem>
    );

    const handleChange = (event: any) => {
        onChange(event);
    };

    return (
        <Grid size={{ xs: 12, sm: 6 }}>
            <FormControl fullWidth classes={classes}>
                <Typography variant="body1" className={mainContainer.labelStyle}>
                    {formatMessage(textMap.treatmentReason)}&nbsp;*
                </Typography>
                <Select
                    disabled={disabled}
                    onChange={handleChange}
                    classes={classes}
                    labelId="labelTreatmentReasonSelect"
                    label={formatMessage(textMap.treatmentReason)}
                    fullWidth
                    className={mainContainer.selectInput}
                    key={defaultValue} // used to make it possible to change the default value without warnings
                    defaultValue={defaultValue}
                    value={value}
                >
                    {noOptionsAvailable ? (
                        <MenuItem value={noOptionsValue}>{formatMessage(textMap.noTreatmentReasonAvailable)}</MenuItem>
                    ) : (
                        reasonList.map(renderMenuItem)
                    )}
                </Select>
            </FormControl>
        </Grid>
    );
};
